export class TopMenuData {
  public id: number
  public name: string
  public key: string
  public value: number
  public color: string
  constructor(
    id: number,
    name: string,
    key: string,
    value: number,
    color: string
  ) {
    this.id = id
    this.name = name
    this.key = key
    this.value = value
    this.color = color
  }
}

export class ChartData {
  public period: string
  public value: number
  constructor(period: string, value: number) {
    this.period = period
    this.value = value
  }
}

export class AccessRateChartsData {
  public month: number
  public percentage: number
  public totalUserAccess: number
  public totalUserVisit: number
  constructor(
    month: number,
    percentage: number,
    totalUserAccess: number,
    totalUserVisit: number
  ) {
    this.month = month
    this.percentage = percentage
    this.totalUserAccess = totalUserAccess
    this.totalUserVisit = totalUserVisit
  }
}

export class UserActiveData {
  public id: number
  public salesCode: string
  public salesName: string
  public dealerName: string
  public dealerCode: string
  public dealerCity: string
  public totalAccess: number
  public position: string
  public lastAccess: number
  constructor(
    id: number,
    salesCode: string,
    salesName: string,
    dealerName: string,
    dealerCode: string,
    dealerCity: string,
    totalAccess: number,
    position: string,
    lastAccess: number
  ) {
    this.id = id
    this.salesCode = salesCode
    this.dealerCode = dealerCode
    this.dealerName = dealerName
    this.dealerCity = dealerCity
    this.salesName = salesName
    this.totalAccess = totalAccess
    this.position = position
    this.lastAccess = lastAccess
  }
}

export class PktData {
  public id: number
  public salesCode: string
  public salesName: string
  public dealerName: string
  public totalReport: number
  constructor(
    id: number,
    salesCode: string,
    salesName: string,
    dealerName: string,
    totalReport: number
  ) {
    this.id = id
    this.salesCode = salesCode
    this.dealerName = dealerName
    this.salesName = salesName
    this.totalReport = totalReport
  }
}

export class MaterialAccess {
  public category: string
  public totalViews: number
  public fileCode: string
  public title: string
  constructor(
    category: string,
    totalViews: number,
    fileCode: string,
    title: string
  ) {
    this.category = category
    this.totalViews = totalViews
    this.fileCode = fileCode
    this.title = title
  }
}
export class UserReport {
  public success: boolean
  public message: string
  public topMenu?: TopMenuData[]
  public chart?: ChartData[]
  public accessRateCharts?: AccessRateChartsData[]
  public userActive?: UserActiveData[]
  public pktData?: PktData[]
  public materialAccess?: MaterialAccess[]
  constructor(
    success: boolean,
    message: string,
    topMenu?: TopMenuData[],
    chart?: ChartData[],
    accessRateCharts?: AccessRateChartsData[],
    userActive?: UserActiveData[],
    pktData?: PktData[],
    materialAccess?: MaterialAccess[]
  ) {
    this.success = success
    this.message = message
    this.topMenu = topMenu
    this.chart = chart
    this.accessRateCharts = accessRateCharts
    this.userActive = userActive
    this.pktData = pktData
    this.materialAccess = materialAccess
  }
}
